// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__6iD0v","body":"Alert_body__gi+Sa"};